import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { emprestimosService } from "@/modules/biblioteca/services/emprestimosService";

const QUERY_KEY_EMPRESTIMOS = ["emprestimos"];

export function useEmprestimos() {
  return useQuery({
    queryKey: QUERY_KEY_EMPRESTIMOS,
    queryFn: emprestimosService.listarTodos,
  });
}

/** Fase 6: recebe `pessoa.id` (Núcleo), não mais o id de auth (`perfil.id`). */
export function useMeusEmprestimos(pessoaId: string | undefined) {
  return useQuery({
    queryKey: [...QUERY_KEY_EMPRESTIMOS, "meus", pessoaId],
    queryFn: () => emprestimosService.listarMeusEmprestimos(pessoaId as string),
    enabled: !!pessoaId,
  });
}

function useInvalidarEmprestimosELivros() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: QUERY_KEY_EMPRESTIMOS });
    // Aprovar/devolver muda quantidade_disponivel em livros.
    queryClient.invalidateQueries({ queryKey: ["livros"] });
  };
}

export function useSolicitarEmprestimo() {
  const invalidar = useInvalidarEmprestimosELivros();
  return useMutation({
    mutationFn: (livroId: string) => emprestimosService.solicitar(livroId),
    onSuccess: invalidar,
  });
}

export function useAprovarEmprestimo() {
  const invalidar = useInvalidarEmprestimosELivros();
  return useMutation({
    mutationFn: ({ id, diasPrazo }: { id: string; diasPrazo?: number }) =>
      emprestimosService.aprovar(id, diasPrazo),
    onSuccess: invalidar,
  });
}

export function useRejeitarEmprestimo() {
  const invalidar = useInvalidarEmprestimosELivros();
  return useMutation({
    mutationFn: ({ id, motivo }: { id: string; motivo?: string }) =>
      emprestimosService.rejeitar(id, motivo),
    onSuccess: invalidar,
  });
}

export function useRegistrarDevolucao() {
  const invalidar = useInvalidarEmprestimosELivros();
  return useMutation({
    mutationFn: (id: string) => emprestimosService.registrarDevolucao(id),
    onSuccess: invalidar,
  });
}

export function useMarcarRejeicaoVisualizada() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => emprestimosService.marcarRejeicaoVisualizada(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_EMPRESTIMOS }),
  });
}
